import React, {useEffect, useMemo, useRef} from 'react';
import ParlaysAccordionItem from "./ParlaysAccordionItem";
import CompletedParlaysAccordionItem from "./CompletedParlaysAccordionItem";
import {ParlayStatus} from "../../constants/PickXEnums";

import './ParlaysAccordion.style.scss';
const ParlaysAccordion = ({ vm }) => {
    const sortedParlays = useMemo(
        () => [...vm.parlays].sort((a, b) => new Date(b.DateCreated) - new Date(a.DateCreated)),
        [vm.parlays]
    );

    const parlayRefs = useRef({});

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const parlayId = queryParams.get("parlayId");

        if (parlayId && parlayRefs.current[parlayId]) {
            parlayRefs.current[parlayId].scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, []);

    return (
        <div className="ParlaysAccordion">
            {sortedParlays.map((parlay) => (
                <div
                    key={parlay.Id}
                    ref={(el) => (parlayRefs.current[parlay.Id] = el)}
                >
                    {parlay.Status === ParlayStatus.Completed ?
                                                    <CompletedParlaysAccordionItem
                                                    parlay={parlay}
                                                    isOpen={vm.openedParlayId === parlay.Id}
                                                    onHeaderClick={() => vm.handleParlaySelected(parlay.Id)}/>
                                                    :
                                                    <ParlaysAccordionItem
                                                    parlay={parlay}
                                                    isOpen={vm.openedParlayId === parlay.Id}
                                                    onHeaderClick={() => vm.handleParlaySelected(parlay.Id)}/>
                    }
                </div>
            ))}
        </div>
    );
};

export default ParlaysAccordion;
